import * as ngCore from '@angular/core'
import * as store from '@attain-apps/fe/web/main/lib/store'

import { getActionsConfig } from './actions'
import { Selectors } from './selectors'
import { State } from './state'

/**
 * Lightweight state for process UI controls that can be used before the
 * process collection is loaded.
 */
@ngCore.Injectable({ providedIn: 'root' })
export class Feature extends store.Feature<
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  constructor() {
    super({
      actions: getActionsConfig(),
      initialState: State.INITIAL,
      name: 'RelayProcesses',
      selectors: () => new Selectors(this),
    })
  }
}
